import type { GameConfig, TokenConfig } from './types';

export const DEFAULT_GAME_CONFIG: GameConfig = {
  drawIntervalSec: 180,
  closeBeforeSec: 15,
  revealIntervalMs: 2000,
  maxDrawsPerTicket: 10,
  houseAccount: 'bingodash',
  checkpointEvery: 480,
  paused: false,
};

/** The token players start on. */
export const DEFAULT_SYMBOL = 'HIVE';

/**
 * Launch limits. Stakes are capped at 10 HIVE per game and a single ticket
 * can win at most 1,000 HIVE, so one lucky 10-spot can't empty the house
 * reserve. Raise these in Firestore `config/tokens` as the bankroll grows.
 *
 * SPS and DEC are wired up but off until there's a reserve for them.
 */
export const DEFAULT_TOKENS: TokenConfig[] = [
  {
    symbol: 'HIVE', displayName: 'HIVE', kind: 'layer1', precision: 3,
    minStake: 100, maxStake: 10_000, maxPayoutPerTicket: 1_000_000, maxWithdrawPerDay: 2_000_000, minWithdraw: 1000,
    enabled: true, stakePresets: [0.1, 0.25, 0.5, 1, 2, 3, 5, 10],
  },
  {
    symbol: 'SWAP.HIVE', displayName: 'SWAP.HIVE', kind: 'engine', precision: 8,
    minStake: 10_000_000, maxStake: 1_000_000_000, maxPayoutPerTicket: 100_000_000_000, maxWithdrawPerDay: 200_000_000_000, minWithdraw: 100_000_000,
    enabled: true, stakePresets: [0.1, 0.25, 0.5, 1, 2, 3, 5, 10],
  },
  {
    symbol: 'SPS', displayName: 'SPS', kind: 'engine', precision: 8,
    minStake: 100_000_000, maxStake: 50_000_000_000, maxPayoutPerTicket: 5_000_000_000_000, maxWithdrawPerDay: 5_000_000_000_000, minWithdraw: 1_000_000_000,
    enabled: false, stakePresets: [1, 5, 10, 20, 50, 100, 250, 500],
  },
  {
    symbol: 'DEC', displayName: 'DEC', kind: 'engine', precision: 3,
    minStake: 10_000, maxStake: 5_000_000, maxPayoutPerTicket: 500_000_000, maxWithdrawPerDay: 500_000_000, minWithdraw: 100_000,
    enabled: false, stakePresets: [10, 20, 50, 100, 250, 500, 1000, 2500],
  },
];
